<template lang="pug">
  div query? {{ query }}
</template>

<script>
import { state } from '..'
import { toRefs } from '@vue/composition-api'

export default {
  setup () {
    return {
      ...toRefs(state)
    }
  }
}
</script>
